import { useCallback, useEffect, useState } from "react";
import SettingsService from "../../services/settings.service";
import { ReactComponent as TitleIcon } from "../../assests/images/settingsBreadCum.svg";
import { Breadcrumb, Card } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";

export default function AboutUs() {
  const [aboutUs, setAboutUs] = useState([]);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    getAboutUs();
  }, []);

  const getAboutUs = useCallback(async () => {
    try {
      const response = await SettingsService.getAboutUs();
      if (response.status === 200) {
        setAboutUs(response.data["aboutUs"].split("\n") || []);
      }
    } catch (error) {}
  }, []);

  return (
    <div>
      <Breadcrumb separator=">" className="hide-xs">
        {/* <Breadcrumb.Item>
          <span onClick={() => navigate("/dashboard")}>
            <HomeIcon height={14} />
          </span>
        </Breadcrumb.Item> */}
        <Breadcrumb.Item>
          <span onClick={() => navigate("/settings")}>
            {t("navigation.other", {
              defaultValue: "Other Services",
            })}
          </span>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <span>
            {t("quickLinks.about_us", {
              defaultValue: "About Us",
            })}
          </span>
        </Breadcrumb.Item>
      </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">
              {t("quickLinks.about_us", {
                defaultValue: "About Us",
              })}
            </h3>
          </div>
        </div>
      </Card>
      <Card
        style={{ minHeight: 300 }}
        className="application-card card-padding"
      >
        <div
          style={{
            textAlign: "justify",
            margin: "2%",
            fontSize: "13px",
            lineHeight: "22px",
          }}
        >
          {aboutUs.map((line, index) => (
            <p key={index}>{line}</p>
          ))}
        </div>
      </Card>
    </div>
  );
}
